import React, { FC } from "react";
import ButtonComponent from "../../buttons/ButtonComponent";
import SquareButton from "../../buttons/SquareButton";
import SVG from "../../svg/Svg";
import { IModules } from "../../../models/IUser";

interface PopupModuleHeaderProps {
  module: IModules;
  onRestart: (identifier: string) => void;
  onClose: () => void;
}

const normalizeErrors = (value: string[] | string | null | undefined): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.map((err) => String(err).trim()).filter((err) => err !== "");
  }
  return String(value)
    .split(",")
    .map((err) => err.trim())
    .filter((err) => err !== "");
};

export const PopupModuleHeader: FC<PopupModuleHeaderProps> = ({
  module,
  onRestart,
  onClose,
}) => {
  const getModuleErrors = (): string[] => {
    const mmbErrors = normalizeErrors(module.last_mmb_errors);
    const smbErrors = normalizeErrors(module.last_smb_errors);

    if (module.device_type === "mmb") return mmbErrors;
    if (module.device_type === "smb") return smbErrors;
    return mmbErrors.length > 0 ? mmbErrors : smbErrors;
  };

  const errors = getModuleErrors();
  const hasErrors = errors.length > 0;

  return (
    <div className="popup_state">
      <div className="popup_state_items">
        <div
          className={
            module.status === "online" ? "popup_status_on" : "popup_status_off"
          }
        >
          {module.status === "online" ? "на связи" : "нет связи"}{" "}
          {module.status === "online" ? SVG["green_dot"] : SVG["red_dot"]}
          {hasErrors ? (
            <div className="popup_station_icons popup_station_errors">
              <div className="error-trigger">
                ошибки <span className="error-count">({errors.length})</span>
              </div>
              <div className="tooltip">
                <div className="tooltip-content">
                  {errors.map((error, index) => (
                    <div key={index} className="tooltip-row">
                      {error}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <ButtonComponent
          onClick={() => onRestart(module.charge_id)}
          title="перезагрузить"
        />
        <SquareButton
          onClick={onClose}
          icon="close"
          background="#48ba67"
          border="none"
          size="24px"
        />
      </div>
    </div>
  );
};
